export const PRIMARY_NAVIGATION = Object.freeze([
  { id: "home", label: "Home", route: "/home", implementationPhase: "03" },
  { id: "explore", label: "Explore", route: "/explore", implementationPhase: "04" },
  { id: "trips", label: "Trips", route: "/trips", implementationPhase: "03" },
  { id: "live", label: "Live", route: "/live", implementationPhase: "07" },
  { id: "profile", label: "Profile", route: "/profile", implementationPhase: "02" }
] as const);

export type PrimaryNavigationId = (typeof PRIMARY_NAVIGATION)[number]["id"];
